
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.5 22.5h-21A1.5 1.5 0 010 21v-8a.5.5 0 011 0v8a.5.5 0 00.5.5h21a.5.5 0 00.5-.5v-8a.5.5 0 011 0v8a1.5 1.5 0 01-1.5 1.5z"}}),_c('path',{attrs:{"d":"M12 15.61a.5.5 0 01-.5-.5V2a.5.5 0 011 0v13.11a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M12 16.5a.5.5 0 01-.36-.15l-5-5.09a.5.5 0 11.72-.7L12 15.29l4.64-4.73a.5.5 0 11.72.7l-5 5.09a.5.5 0 01-.36.15z"}})])
          )
        }
      }
    